import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'
import participant from './entities/participant'

Vue.use(Vuex)
// fix for an issue with Vuex state no longer being accessible in
// dev tools with a 'No Vuex store detected' error being shown instead
Vue.config.devtools = process.env.APP_DEBUG === true

export default new Vuex.Store({
  state: {
    appName: 'Platform Website',
    loggedIn: false,
    websiteConfig: {
      vanity_url: false,
      id: null,
      name: '',
      launch_date: null,
      close_date: null,
      enable_enrollment: 0,
      enrollment_start: null,
      enrollment_end: null,
      url: null,
      external_url: null
    },
    participant: participant,
    participantSetup: participant,
    programs: [],
    programDetails: {},
    programDashboard: {
      programs: []
    },
    cards: {},
    dashboardLayout: [],
    pageDetails: {},
    platformPointCap: {
      pointCap: 0,
      pointsSpentInPeriod: 0
    },
    points: {
      data: [],
      total: 0
    },
    categories: null,
    categoryDetails: null,
    rewards: {
      items: null,
      pagination: null
    },
    rewardDetails: null,
    rewardFilters: [],
    approverClaims: [],
    submitterClaims: [],
    reportData: {},
    chartData: {},
    claimModalData: {},
    claimModalShow: false,
    claimModalType: '',
    claimModalMessage: null,
    savedRewards: [],
    leaderboardModalData: {},
    leaderboardModalShow: false
  },
  actions,
  getters,
  mutations,
  modules: {},
  plugins: []
})



// WEBPACK FOOTER //
// ./src/store/index.js